'use es6';

import { localStorage } from 'conversations-platform/localStorage';
export const clearCommonReplyDraft = draftKey => {
  try {
    localStorage.removeItem(draftKey);
  } catch (error) {
    //
  }
};